import paths from '@/router/paths'
import { disabledRoutes } from './data/roles'

export default {
  /**
   * @return {String[]} アクセスできないルートのnameを配列で返す
   */
  disabledPathNames: ({ user }) => user.roleId ? disabledRoutes.get(user.roleId) : [],

  /**
   * @return {String[]} アクセスできないルートのpathを配列で返す
   */
  disabledPaths: (state, { disabledPathNames }) =>
    disabledPathNames.map(n => paths.find(p => p.name === n).path.split('/')[1])
}
